export const TYPE_BROADCAST = 'broadcast';
export const TYPE_SCHEDULE = 'schedule';
export const TYPE_REGISTRATION = 'registration';
export const TYPE_MEMBERS = 'members';
export const TYPE_PROGRAM = 'program';